﻿(() => {
  const ROOT_SELECTOR = '[data-hr-product-orbit-owned]';
  const INITIALIZED_ATTRIBUTE = 'data-hr-product-orbit-initialized';
  const FLAVOR_SELECTED_CLASSES = {
    Tropic: 'r-34v9fy',
    Berry: 'r-167xd1i',
  };
  const FLAVOR_RIDS = {
    Tropic: 'f103ea00-f113-4078-9f4a-cb97af1416e1',
    Berry: 'f6c5b4cb-8225-4e69-8789-0339e94591ec',
  };
  const PACK_SELECTED_CLASSES = {
    '6': 'r-1f027yq',
    '12': 'r-xh1egh',
    '24': 'r-17kqcoz',
  };
  const PACK_RIDS = {
    '6': '17d6d473-986b-4421-903a-2723bac5c571',
    '12': 'd6eee79c-0ee9-4ad8-8851-a2c17a587998',
    '24': 'a9ea9eb2-8aa8-47b0-b9f6-308aada06cec',
  };
  const PACK_DETAILS_RIDS = {
    '6': '4c194f57-99cc-4d5a-93a2-308c6b3d1aca',
    '12': '5b8f2085-c8db-463a-bbb5-2a569ddffd2d',
    '24': 'aad43b07-503e-473a-9c9a-347772419500',
  };
  const PACK_DETAIL_SELECTED_CLASSES = {
    '6': 'r-ait4al',
    '12': 'r-2mazph',
    '24': 'r-m0togm',
  };
  const PACK_DETAIL_COPY = {
    '6': [
      ['821851ea-0633-44cf-936b-426a475ece96', 'Pause, skip or cancel anytime'],
      ['2371ddc8-a950-4db1-8d24-e20f2ef3237d', 'Earn 1.5x Rider Rewards points'],
      ['3a1a4506-9d35-4aaf-8ded-0c81dbc4b4ab', 'No dispensary taxes'],
      ['dee4bc18-f6d3-4584-aab5-d36a9c31a168', 'Save 5% forever'],
    ],
    '12': [
      ['2c1d0b04-f0c4-46f9-8153-addff9e77640', 'Pause, skip or cancel anytime'],
      ['bfe546af-90c7-45c0-9eac-e789463e1990', 'Earn 1.5x Rider Rewards points'],
      ['00d3fc15-1a25-45d8-8667-573b665b7141', 'No dispensary taxes'],
      ['1c0b22a8-2ff9-409d-9059-77ffa9572b22', 'Save 5% forever'],
    ],
    '24': [
      ['015bc8db-be65-48dd-b9f3-84d88f11b252', 'Pause, skip or cancel anytime'],
      ['16c61b09-3619-4a68-9432-d4d398420c59', 'Earn 1.5x Rider Rewards points'],
      ['6fc87351-b62d-457b-aef5-bc3c3149d30a', 'No dispensary taxes'],
      ['27701846-6517-4f62-9756-7aacd0278173', 'Save 5% forever'],
    ],
  };
  const PACK_FREE_SHIPPING_ROW_RIDS = {
    '12': '14cebd16-2606-4de7-b6f5-f294621c7d1b',
    '24': 'a7105283-f3ed-4cd2-a29c-c3b44e09b0dc',
  };
  const SHOP_NOW_RIDS = [
    'c2fac1c1-9125-4cb1-93b0-c64070297931',
    '00ae44c1-98f0-4b6f-83be-971f777bb0a5',
    '9ec30e6d-b30a-4163-a5ba-1578f3c87088',
    '2ae12040-7252-42ec-88f7-752e9a273b42',
    '5c2ad3f4-eb8e-49a3-99c3-fbf4343569e6',
  ];
  const PRODUCT_LINKS = {
    '21534812-6d60-45d7-8a21-815f327191d6': 'spirit',
    '5336c6a7-7fba-4180-9ab1-730f8ceb7c00': 'rush',
    '733dbc51-3ba3-4523-be50-755de352cddd': 'vibe',
    'c6dd9eaf-de03-4dd1-8ffa-e60a75f8b0e4': 'rush',
    'd867556e-5d41-4aec-a7e1-54e6ff633640': 'vibe',
    'c5f14ee4-9384-4613-bf50-ae9d1b8b91a8': 'citrusVibe',
  };
  const SUBSCRIPTION_RID = '74ea9ee4-5fc5-40db-a57a-580201e45f3e';
  const ONE_TIME_RID = 'd5ee2ae8-b433-4951-b617-d31abfd32770';
  const SUBSCRIPTION_SELECTED_CLASS = 'r-122wea0';
  const ONE_TIME_SELECTED_CLASS = 'r-1lz2b66';
  const ATC_RID = 'e7e19110-224d-48bd-8fbd-e6f538fcee40';
  const ATC_LABEL_RID = '087402d9-16cc-4f4f-b863-c581225fa42a';
  const SHOP_NOW_TARGET_RID = '2f696450-80fb-4fdc-ad26-2829c699d7a0';
  const SUBSCRIPTION_PRICE_RID = '4d79ae71-41ae-4ecd-aec5-f66d318e4e7b';
  const ONE_TIME_PRICE_RID = 'e2d6f936-6dd5-4ec1-a845-f1374f14d51b';
  const SUBSCRIPTION_UNIT_PRICE_RIDS = [
    '8d839aa3-749f-4a71-bb05-3c5ff8c437a3',
    '7c609e28-408c-402c-a6b1-cdb8777c26a8',
    '11ad2eb0-9e85-419b-834d-3b3fae08f888',
  ];
  const SUBSCRIPTION_UNIT_PRICE_SELECTED_CLASSES = ['r-15og9lj', 'r-lsg7sf', 'r-1n11sjj'];
  const ONE_TIME_UNIT_PRICE_RIDS = [
    '6aed8682-de12-459a-a3d4-79529761539a',
    'cc55ac8e-98a0-461b-a741-3d67e1fb1f2e',
    '376911a0-336b-465a-800c-a5d9215a9325',
  ];
  const ONE_TIME_UNIT_PRICE_SELECTED_CLASSES = ['r-5khde3', 'r-1itqz1e', 'r-10w7wxs'];
  const THUMBNAIL_SELECTED_CLASS = 'r-8awaoj';
  const REWARD_MODAL_RIDS = [
    '7301b347-0e11-4e16-96e0-8b958aeeac50',
    '6b998182-493f-4ad0-a864-3239c01b6fd0',
    '94996cf1-c4fd-42d3-8ba7-73b6bb697794',
  ];

  const byRid = (root, rid) => root.querySelector(`[data-rid="${rid}"]`);

  const onKeyboardActivate = (element, callback) => {
    element.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      callback(event);
    });
  };

  const getConfig = (root) => {
    const configElement = root.querySelector('[data-hr-product-orbit-product]');
    if (!configElement) return null;

    try {
      return JSON.parse(configElement.textContent);
    } catch (error) {
      console.error('[High Rider ORBIT] Invalid product configuration.', error);
      return null;
    }
  };

  const formatMoney = (cents, moneyFormat) => {
    const amount = Number(cents || 0) / 100;
    const withCommas = amount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    const withoutTrailingZeros = amount.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
    const format = moneyFormat || '${{amount}}';

    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(amount).toLocaleString('en-US'))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withCommas.replace(/,/g, 'X').replace(/\./g, ',').replace(/X/g, '.'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, Math.round(amount).toLocaleString('de-DE'))
      .replace(/\{\{\s*amount\s*\}\}/g, withCommas)
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, withCommas.replace(/,/g, "'"))
      .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, Math.round(amount).toLocaleString('fr-FR'))
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, withCommas.replace(/,/g, ' '))
      .replace(/\{\{\s*amount_no_trailing_zeros\s*\}\}/g, withoutTrailingZeros);
  };

  const replaceParagraphText = (element, text) => {
    if (!element) return;
    const paragraph = element.querySelector('p');
    if (paragraph) paragraph.textContent = text;
    else element.textContent = text;
  };

  const normalizePackDetails = (root) => {
    const populatedRewardIcon = REWARD_MODAL_RIDS
      .map((rid) => byRid(root, rid)?.querySelector('img[src]'))
      .find(Boolean);

    Object.entries(PACK_DETAIL_COPY).forEach(([pack, rows]) => {
      const details = byRid(root, PACK_DETAILS_RIDS[pack]);
      if (!details) return;

      rows.forEach(([rid, text]) => {
        const element = byRid(details, rid);
        const paragraph = element?.querySelector('p');
        if (paragraph && paragraph.textContent.trim() !== text) paragraph.textContent = text;
      });

      const freeShippingRow = byRid(details, PACK_FREE_SHIPPING_ROW_RIDS[pack]);
      if (freeShippingRow) freeShippingRow.hidden = true;
    });

    if (!populatedRewardIcon) return;
    REWARD_MODAL_RIDS.forEach((rid) => {
      const image = byRid(root, rid)?.querySelector('img');
      if (!image || image.getAttribute('src')) return;
      image.src = populatedRewardIcon.currentSrc || populatedRewardIcon.src;
      image.alt = populatedRewardIcon.alt || '';
    });
  };

  const initializeCarousel = (root, config) => {
    const carousel = root.querySelector('[data-replo-carousel="true"]');
    if (!carousel) return null;

    const mainTrack = carousel.querySelector('[data-replo-part="slide-track"][data-replo-root-id*="R2fmsj2"]');
    const thumbnailTrack = carousel.querySelector('[data-replo-part="slide-track"][data-replo-root-id*="Rnmsj2"]');
    if (!mainTrack || !thumbnailTrack) return null;

    const mainTemplate = mainTrack.querySelector('[data-replo-part="slide"]');
    const thumbnailTemplate = thumbnailTrack.querySelector('[data-replo-part="slide"]');
    if (!mainTemplate || !thumbnailTemplate) return null;

    const liveRegion = carousel.querySelector('[aria-live="polite"]');
    const previousButton = carousel.querySelector('[data-direction="previous"]');
    const nextButton = carousel.querySelector('[data-direction="next"]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let mainSlides = [];
    let thumbnailSlides = [];
    let activeIndex = 0;
    let touchStartX = null;
    let currentFlavor = null;

    const makeSlide = (template, media, index, isThumbnail) => {
      const slide = template.cloneNode(true);
      const image = slide.querySelector('img');
      const picture = slide.querySelector('picture');
      const url = typeof media === 'string' ? media : (isThumbnail ? media.thumbnailUrl || media.url : media.url);

      slide.id = `hr-product-orbit-${isThumbnail ? 'thumbnail' : 'gallery'}-${index + 1}`;
      slide.dataset.slideIndex = String(index);
      slide.dataset.slideSourceIndex = String(index);
      slide.dataset.isActive = index === 0 ? 'true' : 'false';
      slide.dataset.hrProductOrbitSlide = String(index);
      slide.removeAttribute('data-is-cloned');
      slide.setAttribute('aria-hidden', index === 0 ? 'false' : 'true');
      slide.setAttribute('aria-label', `Slide ${index + 1}`);
      slide.tabIndex = isThumbnail ? 0 : -1;

      if (isThumbnail) {
        slide.setAttribute('role', 'button');
        slide.setAttribute('aria-label', `View product image ${index + 1}`);
        slide.setAttribute('aria-current', index === 0 ? 'true' : 'false');
        slide.dataset.hrProductOrbitThumbnail = 'true';
        slide.firstElementChild?.classList.toggle(THUMBNAIL_SELECTED_CLASS, index === 0);
      }

      if (picture) picture.removeAttribute('id');
      if (image) {
        image.src = url;
        image.alt = (typeof media === 'object' && media.alt) || 'ORBIT product image';
        image.loading = index === 0 && !isThumbnail ? 'eager' : 'lazy';
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
      }
      slide.querySelectorAll('source').forEach((source) => source.remove());
      return slide;
    };

    const setActive = (nextIndex, shouldFocusThumbnail = false) => {
      if (!mainSlides.length) return;
      activeIndex = (nextIndex + mainSlides.length) % mainSlides.length;
      mainTrack.style.transitionDuration = reducedMotion.matches ? '0ms' : '300ms';
      mainTrack.style.transitionProperty = 'transform';
      mainTrack.style.transform = `translate3d(-${activeIndex * 100}%, 0, 0)`;

      mainSlides.forEach((slide, index) => {
        const isActive = index === activeIndex;
        slide.dataset.isActive = String(isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });
      thumbnailSlides.forEach((slide, index) => {
        const isActive = index === activeIndex;
        slide.dataset.isActive = String(isActive);
        slide.setAttribute('aria-current', String(isActive));
        slide.firstElementChild?.classList.toggle(THUMBNAIL_SELECTED_CLASS, isActive);
        if (isActive && thumbnailTrack.parentElement) {
          thumbnailTrack.parentElement.scrollTo({
            left: slide.offsetLeft,
            behavior: reducedMotion.matches ? 'auto' : 'smooth',
          });
        }
      });
      if (liveRegion) liveRegion.textContent = `Slide ${activeIndex + 1} of ${mainSlides.length}`;
      if (shouldFocusThumbnail) thumbnailSlides[activeIndex].focus({ preventScroll: true });
    };

    const setMedia = (flavor) => {
      const media = config.mediaByFlavor?.[flavor];
      if (!Array.isArray(media) || !media.length) return;
      if (currentFlavor === flavor && mainSlides.length) return;
      currentFlavor = flavor;
      mainSlides = media.map((item, index) => makeSlide(mainTemplate, item, index, false));
      thumbnailSlides = media.map((item, index) => makeSlide(thumbnailTemplate, item, index, true));
      mainTrack.replaceChildren(...mainSlides);
      thumbnailTrack.replaceChildren(...thumbnailSlides);
      thumbnailSlides.forEach((slide, index) => {
        slide.addEventListener('click', () => setActive(index));
        onKeyboardActivate(slide, () => setActive(index));
        slide.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          setActive(index + (event.key === 'ArrowRight' ? 1 : -1), true);
        });
      });
      activeIndex = 0;
      setActive(0);
    };
    previousButton?.addEventListener('click', () => setActive(activeIndex - 1));
    nextButton?.addEventListener('click', () => setActive(activeIndex + 1));
    carousel.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX ?? null;
    }, { passive: true });
    carousel.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const touchEndX = event.changedTouches[0]?.clientX ?? touchStartX;
      const distance = touchEndX - touchStartX;
      touchStartX = null;
      if (Math.abs(distance) < 45) return;
      setActive(activeIndex + (distance < 0 ? 1 : -1));
    }, { passive: true });

    return { setMedia };
  };

  const initializeCollapsibles = (root) => {
    root.querySelectorAll('[data-replo-collapsible="true"]').forEach((collapsible) => {
      const trigger = Array.from(collapsible.children).find((child) => child.matches('[role="button"][aria-controls]'));
      if (!trigger) return;
      const panel = root.querySelector(`#${CSS.escape(trigger.getAttribute('aria-controls'))}`);
      if (!panel) return;
      const iconPath = trigger.querySelector('svg path')?.getAttribute('d') || '';
      trigger.dataset.hrProductOrbitIcon = iconPath.includes('v3h3') || iconPath.includes('v-3h-3') ? 'plus' : 'chevron';

      const setExpanded = (expanded) => {
        collapsible.dataset.state = expanded ? 'open' : 'closed';
        trigger.setAttribute('aria-expanded', String(expanded));
        panel.hidden = !expanded;
      };
      const toggle = () => setExpanded(trigger.getAttribute('aria-expanded') !== 'true');

      trigger.setAttribute('aria-expanded', 'false');
      setExpanded(collapsible.dataset.state === 'open' && !panel.hidden);
      trigger.addEventListener('click', toggle);
      onKeyboardActivate(trigger, toggle);
    });
  };

  const initializeNavigation = (root, config) => {
    const smoothBehavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    const shopNowTarget = byRid(root, SHOP_NOW_TARGET_RID);
    if (shopNowTarget && !shopNowTarget.id) shopNowTarget.id = 'hr-product-orbit-shop-now';
    if (shopNowTarget && !shopNowTarget.hasAttribute('tabindex')) shopNowTarget.tabIndex = -1;

    SHOP_NOW_RIDS.forEach((rid) => {
      const control = byRid(root, rid);
      if (!control || !shopNowTarget) return;
      control.setAttribute('role', control.tagName === 'A' ? 'link' : 'button');
      if (!control.hasAttribute('tabindex')) control.tabIndex = 0;
      control.setAttribute('aria-controls', shopNowTarget.id);
      if (control.tagName === 'A') control.setAttribute('href', `#${shopNowTarget.id}`);
      const activate = (event) => {
        event.preventDefault();
        shopNowTarget.scrollIntoView({ behavior: smoothBehavior, block: 'start' });
        window.setTimeout(() => shopNowTarget.focus({ preventScroll: true }), smoothBehavior === 'smooth' ? 500 : 0);
      };
      control.addEventListener('click', activate);
      onKeyboardActivate(control, activate);
    });

    Object.entries(PRODUCT_LINKS).forEach(([rid, routeKey]) => {
      const control = byRid(root, rid);
      const href = config.routes?.[routeKey];
      if (!control || !href) return;
      control.setAttribute('role', 'link');
      if (!control.hasAttribute('tabindex')) control.tabIndex = 0;
      if (control.tagName === 'A') control.setAttribute('href', href);
      const activate = (event) => {
        event.preventDefault();
        window.location.assign(href);
      };
      control.addEventListener('click', activate);
      onKeyboardActivate(control, activate);
    });
  };

  const initializeReviews = (root) => {
    const badges = root.querySelectorAll('.jdgm-preview-badge');
    if (!badges.length) return;

    badges.forEach((badge) => {
      badge.setAttribute('role', 'link');
      badge.setAttribute('tabindex', '0');
      badge.setAttribute('aria-controls', 'judgeme_product_reviews');
      const activate = (event) => {
        const widget = document.getElementById('judgeme_product_reviews') || document.querySelector('.jdgm-review-widget');
        if (!widget) return;
        event.preventDefault();
        widget.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start',
        });
      };
      badge.addEventListener('click', activate);
      onKeyboardActivate(badge, activate);
    });
  };

  const initializeModal = (root) => {
    const modal = root.closest('.hr-product-orbit-section')?.querySelector('[data-hr-product-orbit-modal]')
      || document.querySelector('[data-hr-product-orbit-modal]');
    const openers = REWARD_MODAL_RIDS.map((rid) => byRid(root, rid)).filter(Boolean);
    const closeButton = modal?.querySelector('[data-hr-product-orbit-modal-close]');
    if (!modal || !openers.length) return;

    const open = () => {
      if (typeof modal.showModal === 'function') modal.showModal();
      else modal.setAttribute('open', '');
    };
    const close = () => {
      if (typeof modal.close === 'function') modal.close();
      else modal.removeAttribute('open');
    };
    openers.forEach((opener) => {
      opener.setAttribute('role', 'button');
      if (!opener.hasAttribute('tabindex')) opener.tabIndex = 0;
      opener.setAttribute('aria-haspopup', 'dialog');
      opener.setAttribute('aria-controls', 'hr-product-orbit-modal-title');
      opener.addEventListener('click', open);
      onKeyboardActivate(opener, open);
    });
    closeButton?.addEventListener('click', close);
    modal.addEventListener('click', (event) => {
      if (event.target === modal) close();
    });
  };

  const initializeBackInStock = (root) => {
    const control = byRid(root, '3cd1b5e0-52c5-431a-bf5d-823adc9a2635');
    if (!control) return;
    const activate = () => {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'VDfXAT']);
    };
    control.setAttribute('role', 'button');
    control.tabIndex = 0;
    control.addEventListener('click', activate);
    onKeyboardActivate(control, activate);
  };

  const initializeProductForm = (root, config, gallery) => {
    const form = root.querySelector('form[action*="/cart/add"]');
    const variantInput = form?.querySelector('input[name="id"]');
    const quantityInput = form?.querySelector('input[name="quantity"]');
    const sellingPlanInput = form?.querySelector('input[name="selling_plan"]');
    const addButton = byRid(root, ATC_RID);
    const buttonLabel = byRid(root, ATC_LABEL_RID);
    const subscribeControl = byRid(root, SUBSCRIPTION_RID);
    const oneTimeControl = byRid(root, ONE_TIME_RID);
    const planSelect = byRid(root, '8684ecd5-b96b-4cf2-8212-201a943f9e78');
    if (!form || !variantInput || !quantityInput || !sellingPlanInput || !addButton) return;

    normalizePackDetails(root);

    const variants = Array.isArray(config.variants) ? config.variants : [];
    const optionNames = Array.isArray(config.optionNames) ? config.optionNames : [];
    const unavailableFlavors = new Set(
      (Array.isArray(config.unavailableFlavors) ? config.unavailableFlavors : [])
        .map((value) => String(value))
    );
    const flavorIndexByName = optionNames.findIndex((name) => /flavo(?:u)?r/i.test(String(name)));
    const packIndexByName = optionNames.findIndex((name) => /pack|size|bottle|quantity|count/i.test(String(name)));
    const flavorIndexByValue = variants[0]?.options?.findIndex((_, index) => variants
      .some((variant) => ['Tropic', 'Berry'].includes(String(variant.options?.[index])))) ?? -1;
    const packIndexByValue = variants[0]?.options?.findIndex((_, index) => variants
      .some((variant) => ['6', '12', '24'].includes(String(variant.options?.[index])))) ?? -1;
    const flavorIndex = flavorIndexByName >= 0 ? flavorIndexByName : (flavorIndexByValue >= 0 ? flavorIndexByValue : 1);
    const packIndex = packIndexByName >= 0 ? packIndexByName : (packIndexByValue >= 0 ? packIndexByValue : 0);
    const requestedVariantId = new URL(window.location.href).searchParams.get('variant');
    const defaultVariant = variants.find((variant) => String(variant.id) === String(requestedVariantId) && variant.available)
      || variants.find((variant) => String(variant.id) === String(config.defaultVariantId) && variant.available)
      || variants.find((variant) => String(variant.id) === String(config.defaultVariantId))
      || variants.find((variant) => variant.available)
      || variants[0];
    let selectedVariant = defaultVariant;
    let selectedFlavor = String(defaultVariant?.options?.[flavorIndex] || 'Tropic');
    let selectedPack = String(defaultVariant?.options?.[packIndex] || '12');
    let purchaseMode = 'subscription';
    let selectedSellingPlanId = Number(config.defaultSellingPlanId);
    let loading = false;

    const flavorControls = Object.entries(FLAVOR_RIDS).map(([value, rid]) => ({
      value,
      element: byRid(root, rid),
    })).filter(({ element }) => element);
    const packControls = Object.entries(PACK_RIDS).map(([value, rid]) => ({
      value,
      element: byRid(root, rid),
    })).filter(({ element }) => element);

    flavorControls.forEach(({ value, element }) => {
      if (!unavailableFlavors.has(String(value))) return;
      const soldOutLabel = String(config.soldOutLabel || 'Sold Out');
      element.dataset.hrProductOrbitUnavailable = 'true';
      element.setAttribute('aria-disabled', 'true');
      element.setAttribute('aria-selected', 'false');
      element.setAttribute('aria-label', `${value}, ${soldOutLabel}`);
      element.tabIndex = -1;
      Object.values(FLAVOR_SELECTED_CLASSES).forEach((className) => element.classList.remove(className));
      element.querySelectorAll('p').forEach((label) => {
        label.textContent = `${value} — ${soldOutLabel}`;
      });
      const blockUnavailableSelection = (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
      };
      element.addEventListener('click', blockUnavailableSelection, true);
      element.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') blockUnavailableSelection(event);
      }, true);
    });

    const availablePlan = (variant) => {
      const plans = Array.isArray(variant?.sellingPlans) ? variant.sellingPlans : [];
      const allocation = plans.find((plan) => Number(plan.id) === Number(selectedSellingPlanId)) || plans[0] || null;
      if (!allocation) return null;
      const definition = config.sellingPlans?.find((plan) => Number(plan.id) === Number(allocation.id));
      return { ...allocation, name: definition?.name || '' };
    };

    const setButtonLabel = (text) => replaceParagraphText(buttonLabel, text);

    const updatePrices = () => {
      if (!selectedVariant) return;
      const bottleCount = Math.max(1, Number(selectedVariant.options?.[packIndex]) || 1);
      const plan = availablePlan(selectedVariant);
      replaceParagraphText(byRid(root, ONE_TIME_PRICE_RID), formatMoney(selectedVariant.price, config.moneyFormat));

      const oneTimeUnitPrice = `${formatMoney(Math.round(Number(selectedVariant.price) / bottleCount), config.moneyFormat)} ea.`;
      ONE_TIME_UNIT_PRICE_RIDS.forEach((rid, index) => {
        const element = byRid(root, rid);
        replaceParagraphText(element, oneTimeUnitPrice);
        if (!element) return;
        element.classList.remove(...ONE_TIME_UNIT_PRICE_SELECTED_CLASSES);
        if (index === ['6', '12', '24'].indexOf(String(bottleCount))) {
          element.classList.add(ONE_TIME_UNIT_PRICE_SELECTED_CLASSES[index]);
        }
      });

      if (plan) {
        replaceParagraphText(byRid(root, SUBSCRIPTION_PRICE_RID), formatMoney(plan.price, config.moneyFormat));
        const subscriptionUnitPrice = `${formatMoney(Math.round(Number(plan.price) / bottleCount), config.moneyFormat)} ea.`;
        SUBSCRIPTION_UNIT_PRICE_RIDS.forEach((rid, index) => {
          const element = byRid(root, rid);
          replaceParagraphText(element, subscriptionUnitPrice);
          if (!element) return;
          element.classList.remove(...SUBSCRIPTION_UNIT_PRICE_SELECTED_CLASSES);
          if (index === ['6', '12', '24'].indexOf(String(bottleCount))) {
            element.classList.add(SUBSCRIPTION_UNIT_PRICE_SELECTED_CLASSES[index]);
          }
        });
        if (planSelect) planSelect.value = String(plan.id);
      }
    };

    const updatePurchaseMode = (mode) => {
      const plan = availablePlan(selectedVariant);
      purchaseMode = mode === 'subscription' && plan ? 'subscription' : 'one-time';
      if (plan) selectedSellingPlanId = Number(plan.id);

      [[subscribeControl, purchaseMode === 'subscription', SUBSCRIPTION_SELECTED_CLASS],
        [oneTimeControl, purchaseMode === 'one-time', ONE_TIME_SELECTED_CLASS]].forEach(([control, isSelected, selectedClass]) => {
        if (!control) return;
        control.setAttribute('role', 'radio');
        control.setAttribute('aria-checked', String(isSelected));
        control.classList.toggle(selectedClass, isSelected);
        const radio = control.nextElementSibling?.matches('input[type="radio"]') ? control.nextElementSibling : null;
        if (radio) radio.checked = isSelected;
      });
      sellingPlanInput.value = purchaseMode === 'subscription' && plan ? String(plan.id) : '';
      updatePrices();
    };

    const updateVariant = (variant) => {
      if (!variant) return;
      selectedVariant = variant;
      selectedFlavor = String(variant.options?.[flavorIndex] || selectedFlavor);
      selectedPack = String(variant.options?.[packIndex] || selectedPack);
      variantInput.value = String(variant.id);
      quantityInput.value = '1';

      flavorControls.forEach(({ value, element }) => {
        const isSelected = selectedFlavor === value;
        Object.values(FLAVOR_SELECTED_CLASSES).forEach((className) => element.classList.remove(className));
        if (isSelected) element.classList.add(FLAVOR_SELECTED_CLASSES[value]);
        element.setAttribute('aria-selected', String(isSelected));
      });
      packControls.forEach(({ value, element }) => {
        const isSelected = selectedPack === value;
        Object.values(PACK_SELECTED_CLASSES).forEach((className) => element.classList.remove(className));
        if (isSelected) element.classList.add(PACK_SELECTED_CLASSES[value]);
        element.setAttribute('aria-selected', String(isSelected));
      });
      Object.entries(PACK_DETAILS_RIDS).forEach(([value, rid]) => {
        const details = byRid(root, rid);
        if (!details) return;
        details.dataset.hrProductOrbitPackDetails = value;
        details.classList.toggle(PACK_DETAIL_SELECTED_CLASSES[value], selectedPack === value);
        details.hidden = selectedPack !== value;
      });

      const hasPlan = Boolean(availablePlan(variant));
      if (subscribeControl) subscribeControl.setAttribute('aria-disabled', String(!hasPlan));
      updatePurchaseMode(purchaseMode);
      gallery?.setMedia(selectedFlavor);
      addButton.disabled = !variant.available;
      addButton.setAttribute('aria-disabled', String(!variant.available));
      setButtonLabel(variant.available ? config.addToCartLabel : config.soldOutLabel);
      const nextUrl = new URL(window.location.href);
      nextUrl.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', nextUrl);
    };

    const selectOption = (type, value) => {
      if (type === 'flavor' && unavailableFlavors.has(String(value))) return;
      const flavor = type === 'flavor' ? value : selectedFlavor;
      const pack = type === 'pack' ? value : selectedPack;
      const variant = variants.find((item) => String(item.options?.[flavorIndex]) === String(flavor)
        && String(item.options?.[packIndex]) === String(pack));
      if (variant) updateVariant(variant);
    };

    const bindOptions = (controls, type) => {
      const enabledControls = controls.filter(({ value }) => (
        type !== 'flavor' || !unavailableFlavors.has(String(value))
      ));
      controls.forEach(({ value, element }) => {
        if (type === 'flavor' && unavailableFlavors.has(String(value))) return;
        element.addEventListener('click', () => selectOption(type, value));
        onKeyboardActivate(element, () => selectOption(type, value));
        element.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const currentIndex = enabledControls.findIndex((option) => option.element === element);
          if (currentIndex < 0 || !enabledControls.length) return;
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const next = enabledControls[
            (currentIndex + direction + enabledControls.length) % enabledControls.length
          ];
          next.element.focus();
          selectOption(type, next.value);
        });
      });
    };
    bindOptions(flavorControls, 'flavor');
    bindOptions(packControls, 'pack');

    const bindPurchaseControl = (control, mode) => {
      if (!control) return;
      control.addEventListener('click', () => updatePurchaseMode(mode));
      onKeyboardActivate(control, () => updatePurchaseMode(mode));
      control.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp' && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const nextControl = mode === 'subscription' ? oneTimeControl : subscribeControl;
        nextControl?.focus();
        updatePurchaseMode(mode === 'subscription' ? 'one-time' : 'subscription');
      });
    };
    bindPurchaseControl(subscribeControl, 'subscription');
    bindPurchaseControl(oneTimeControl, 'one-time');
    planSelect?.addEventListener('change', () => {
      selectedSellingPlanId = Number(planSelect.value);
      updatePurchaseMode('subscription');
    });

    const setLoading = (isLoading) => {
      loading = isLoading;
      addButton.classList.toggle('hr-product-orbit-is-loading', isLoading);
      addButton.disabled = isLoading || !selectedVariant?.available;
      addButton.setAttribute('aria-busy', String(isLoading));
      if (!isLoading) {
        setButtonLabel(selectedVariant?.available ? config.addToCartLabel : config.soldOutLabel);
        return;
      }

      const label = buttonLabel?.querySelector('p') || buttonLabel;
      if (!label) return;
      const computed = window.getComputedStyle(label);
      label.innerHTML = '';
      const loadingText = document.createElement('span');
      const spinner = document.createElement('span');
      loadingText.className = 'hr-product-orbit-loading-text';
      loadingText.textContent = 'LOADING';
      loadingText.style.fontFamily = computed.fontFamily;
      loadingText.style.fontSize = computed.fontSize;
      loadingText.style.fontStyle = computed.fontStyle;
      loadingText.style.fontWeight = computed.fontWeight;
      loadingText.style.lineHeight = computed.lineHeight;
      loadingText.style.letterSpacing = computed.letterSpacing;
      loadingText.style.textTransform = computed.textTransform;
      loadingText.style.color = computed.color;
      spinner.className = 'hr-product-orbit-loading-spinner';
      spinner.setAttribute('aria-hidden', 'true');
      label.append(loadingText, spinner);
    };

    const openEliteCart = async () => {
      let refreshRequested = false;

      for (let attempt = 0; attempt < 600; attempt += 1) {
        const backdrop = document.getElementById('EliteCartBackdrop');
        const eliteCartDialog = Array.from(document.querySelectorAll('[role="dialog"]'))
          .find((dialog) => dialog.querySelector('.ec-cart-container') || dialog.closest('.ec-cart-container'));
        const backdropStyles = backdrop ? window.getComputedStyle(backdrop) : null;
        const backdropVisible = backdropStyles
          && backdropStyles.display !== 'none'
          && backdropStyles.visibility !== 'hidden';
        const dialogVisible = eliteCartDialog
          && window.getComputedStyle(eliteCartDialog).display !== 'none'
          && window.getComputedStyle(eliteCartDialog).visibility !== 'hidden';

        if (backdropVisible || dialogVisible) return true;

        if (!refreshRequested && typeof window.EliteCart?.openDrawerWithDataRefresh === 'function') {
          refreshRequested = true;
          try {
            await window.EliteCart.openDrawerWithDataRefresh();
          } catch (error) {
            console.warn('[High Rider ORBIT] EliteCart could not be opened.', error);
          }
        }

        await new Promise((resolve) => window.setTimeout(resolve, 100));
      }

      return false;
    };

    const addToCart = async (event) => {
      event.preventDefault();
      if (loading || !selectedVariant?.available) return;
      const plan = purchaseMode === 'subscription' ? availablePlan(selectedVariant) : null;
      const payload = {
        items: [{
          id: Number(selectedVariant.id),
          quantity: 1,
          ...(plan ? { selling_plan: Number(plan.id) } : {}),
        }],
      };

      setLoading(true);
      try {
        let cartAddUrl = config.routes?.cartAdd || window.routes?.cart_add_url || '/cart/add.js';
        if (!cartAddUrl.endsWith('.js')) cartAddUrl += '.js';
        const response = await fetch(cartAddUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(payload),
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(data.description || data.message || 'Unable to add this item to your cart.');

        root.dispatchEvent(new CustomEvent('high-rider:cart-added', {
          bubbles: true,
          detail: { data, product: config.handle, variantId: selectedVariant.id, sellingPlanId: plan?.id || null },
        }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { data, source: 'hr-product-orbit-owned' } }));
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'hr-product-orbit-owned',
            productVariantId: String(selectedVariant.id),
            cartData: data,
          });
        }
        if (!await openEliteCart()) window.location.assign(config.routes?.cart || '/cart');
      } catch (error) {
        console.error('[High Rider ORBIT] Add to cart failed.', error);
        addButton.dataset.hrProductOrbitError = error.message || 'Unable to add this item to your cart.';
      } finally {
        setLoading(false);
        if (addButton.dataset.hrProductOrbitError) {
          setButtonLabel(addButton.dataset.hrProductOrbitError);
          window.setTimeout(() => {
            delete addButton.dataset.hrProductOrbitError;
            setButtonLabel(selectedVariant?.available ? config.addToCartLabel : config.soldOutLabel);
          }, 3500);
        }
      }
    };

    form.addEventListener('submit', addToCart);
    addButton.addEventListener('click', addToCart);
    updateVariant(defaultVariant);
  };

  const initialize = (scope = document) => {
    scope.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      if (root.hasAttribute(INITIALIZED_ATTRIBUTE)) return;
      const config = getConfig(root);
      if (!config) return;
      root.setAttribute(INITIALIZED_ATTRIBUTE, 'true');
      const gallery = initializeCarousel(root, config);
      initializeCollapsibles(root);
      initializeNavigation(root, config);
      initializeReviews(root);
      initializeModal(root);
      initializeBackInStock(root);
      initializeProductForm(root, config, gallery);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
